module.exports = __webpack_public_path__ + "static/media/72.6c565eb0.svg";